// extracted by mini-css-extract-plugin
export default {"image":"Homepage_image__nsuyY"};